// Mount the Organizations module: hand `createOrganizationsModule` a lazy host (`./organizations-host`,
// which holds the compute hooks) instead of a built one. `service-modules.ts` takes the route from
// HERE, and the router takes the two top-level team pages, so the module cannot be mounted
// unregistered. This file must stay light: it is in the entry chunk. The HTTP clients are not
// members: the data layer reads the shared registry (`@vnetwork/margarita-core/http`).
import { createOrganizationsModule } from '@vnetwork/margarita-organizations';

export const organizations = createOrganizationsModule(() => import('./organizations-host').then((m) => m.organizationsHost));
